export default {
    TerapeutBooking: 'terapeut_booking',
    EasyPractice: 'easypractice',
    Physica: 'physica',
    Psykbase: 'psykbase',
}
